export default "__VITE_ASSET__r_mTjXkF__"